// extracted by mini-css-extract-plugin
export default {"linkPreDocuments":"LinkPreDocuments_linkPreDocuments__OX9ci"};